import type { ImportFromFileFormData } from './ImportFromFileForm'
import type { ImportFileMappingFormData } from './ImportFromFileMapping'

import React from 'react'

type Step = 'form' | 'mapping' | 'processing' | 'errors' | 'success'
export type ImportFromFileContextValue = {
	draft: ImportFromFileFormData
	setDraft: (data: ImportFromFileFormData) => void
	step: Step
	setStep: (step: Step) => void
	headers: string[]
	setHeaders: (headers: string[]) => void
	schemaOptions: { label: string; value: string }[]
	submit: (
		formData: ImportFromFileFormData & ImportFileMappingFormData,
		context: ImportFromFileContextValue
	) => Promise<void>
}

const ImportFromFileContext = React.createContext<
	ImportFromFileContextValue | undefined
>(undefined)

export function useImportFromFile() {
	const context = React.use(ImportFromFileContext)

	if (!context)
		throw new Error(
			'useImportFromFile must be used within ImportFromFileProvider'
		)

	return context
}
export function ImportFromFileProvider({
	children,
	onSubmit,
	schemaOptions,
}: {
	children: React.ReactNode
	onSubmit: (
		formData: ImportFromFileFormData & ImportFileMappingFormData,
		context: ImportFromFileContextValue
	) => Promise<void>
	schemaOptions: { label: string; value: string }[]
}) {
	const [step, setStep] = React.useState<Step>('form')
	const [draft, setDraft] = React.useState<ImportFromFileFormData>({
		ignore_empties: true,
		product_diffs: [],
	})
	const [headers, setHeaders] = React.useState<string[]>([])

	const value = {
		draft,
		setDraft,
		step,
		setStep,
		headers,
		setHeaders,
		schemaOptions,
		submit: onSubmit,
	}

	return <ImportFromFileContext value={value}>{children}</ImportFromFileContext>
}
